import * as angular from 'angular';

"use strict";

angular.module('IconModule', [])

export default 'IconModule';